import {FC, PropsWithChildren} from "react";
import {useIsMobile} from "./hooks/useIsMobile.ts";
import {App, ConfigProvider, ThemeConfig} from "antd";
import locale from "antd/locale/ru_RU";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

const queryClient = new QueryClient();

export const Providers: FC<PropsWithChildren & { theme: ThemeConfig }> = ({ children, theme }) => {
    const isMobile = useIsMobile();

    return (
        <QueryClientProvider client={queryClient}>
            <ConfigProvider locale={locale} theme={theme}>
                <App style={isMobile ? { minHeight: '100%' } : { height: '100%' }}>
                    {children}
                </App>
            </ConfigProvider>
        </QueryClientProvider>
    );
}